import React from "react";
import "./Hero.css";
import { FaArrowRight } from "react-icons/fa";
import heroimg from "../Assets/Frontend_Assets/br.png";
import { Link } from "react-router-dom";

export default function Hero({ onAllProductsClick }) {
  return (
    <section className="lux-hero">
      {/* Ambient glows */}
      <div className="lux-glow lux-glow-left" />
      <div className="lux-glow lux-glow-right" />

      <div className="lux-container">
        {/* LEFT */}
        <div className="lux-content">
          <span className="lux-eyebrow">NATURAL • PREMIUM • TRUSTED</span>

          <h1 className="lux-title">
            Elevating <br />
            <span>Hair, Beard & Skin</span> <br />
            Care Naturally
          </h1>

          <div className="lux-divider" />

          <p className="lux-description">
            PrimeCosmo blends nature and science to craft premium oils and soaps
            designed for visible results, long-term care, and confident living.
          </p>

          <div className="lux-actions">
            <Link to="/contact">
              <button className="lux-btn-primary">
                Contact Us <FaArrowRight />
              </button>
            </Link>

            <button
              className="lux-btn-secondary"
              onClick={onAllProductsClick}
            >
              Explore Products
            </button>
          </div>
        </div>

        {/* RIGHT */}
        <div className="lux-visual">
          <div className="lux-image-frame">
            <img src={heroimg} alt="PrimeCosmo Premium Care" />
          </div>
        </div>
      </div>
    </section>
  );
}
